import {z} from 'zod';

import {PaymentTypeSchema} from '@dms/api/shared';

export const ReceiveNoteCorrectionFormSchema = z.object({
  supplierId: z.string(),
  warehouseId: z.string(),
  authorizationProfileId: z.string(),
  number: z.string().nullish(),
  date: z.date().nullish(),
  invoiceNumber: z.string().nullish(),
  invoiceIssueDate: z.date().nullish(),
  paymentType: PaymentTypeSchema,
  currency: z.string(),
  exchangeRate: z.number().nullish(),
  ncConversion: z.string().nullish(),
  note: z.string().nullish(),
});

export type ReceiveNoteCorrectionForm = z.infer<typeof ReceiveNoteCorrectionFormSchema>;
